module.exports = __webpack_public_path__ + "static/media/2122-service-1-4-min.fd45dc5e.jpg";